import Box from "../Box";
import { MilestonesTimeline } from "./MilestonesTimeline";
import { ProgressInsightsSection } from "./ProgressInsightsSection";
import type { Milestone, MiniStat, OverallProgress } from "./types";

type Props = {
	overallProgress: OverallProgress;
	miniStats: MiniStat[];
	milestones: Milestone[];
};

export const StatsTabContent = ({
	overallProgress,
	miniStats,
	milestones,
}: Props) => {
	return (
		<Box gap={24} paddingHorizontal={16} paddingTop={24} paddingBottom={24}>
			<ProgressInsightsSection
				overallProgress={overallProgress}
				miniStats={miniStats}
			/>
			<MilestonesTimeline milestones={milestones} />
		</Box>
	);
};
